import { render, staticRenderFns } from "./SalesOrder.vue?vue&type=template&id=14bf0d60&scoped=true"
import script from "./SalesOrder.vue?vue&type=script&lang=js"
export * from "./SalesOrder.vue?vue&type=script&lang=js"
import style0 from "./SalesOrder.vue?vue&type=style&index=0&id=14bf0d60&prod&scoped=true&lang=css"
import style1 from "./SalesOrder.vue?vue&type=style&index=1&id=14bf0d60&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bf0d60",
  null
  
)

export default component.exports